import { combineReducers } from 'redux';
import storage from 'redux-persist/lib/storage/session'

import VersionsReducer from './reducer_versions';
import UserReducer from './reducer_user';
import ClaimsReducer from './reducer_claim';
import ClaimoptionsReducer from './reducer_claimoptions';
import VisitsReducer from './reducer_visit';
import ClinicReducer from './reducer_clinic';
import AppConfigReducer from './reducer_app_config';
import SystemAdminReducer from './reducer_system_admin';
import SystemAdminClaimReducer from './reducer_system_admin_claims';
import ElogReducer from './reducer_elog';
import HradminReducer from './reducer_hradmin';
import AppLaunchConfigReducer from './reducer_applaunch_config';
import ProductsReducer from './reducer_products';
import StripeReducer from './reducer_stripe';
import OTPReducer from './reducer_otp';
import EcardReducer from './reducer_ecard';
import notificationReducer from './reducer_notification';
import AuthenticatorReducer from './reducer_authenticator';

const appReducer = combineReducers({
    // state: (state = {}) => state
    versions: VersionsReducer,
    user: UserReducer,
    claims: ClaimsReducer,
    claimOptions: ClaimoptionsReducer,
    visits: VisitsReducer,
    clinics: ClinicReducer,
    appConfig: AppConfigReducer,
    systemAdmin: SystemAdminReducer,
    systemAdminClaims: SystemAdminClaimReducer,
    elogs: ElogReducer,
    hradmin: HradminReducer,
    appLaunchConfig: AppLaunchConfigReducer,
    products: ProductsReducer,
    otp: OTPReducer,
    stripe: StripeReducer,
    ecard: EcardReducer,
    notificationStatus: notificationReducer,
    authenticator: AuthenticatorReducer,
});

const rootReducer = (state, action) => {

    if (action.type === 'USER_LOGOUT') {
        Object.keys(state).forEach(key => {
            storage.removeItem(`persist:${key}`);
        });
        state = undefined;
    }

    return appReducer(state, action);
}

export default rootReducer;
